import React, { Component } from 'react';
import { connect } from 'react-redux';
// import axios from 'axios';
import { getApiData } from './../../api/api';
import './Pdf.css';
import { showLoader } from './../../redux/actions/action_loader';
import { withRouter } from 'react-router-dom';
import AxiosRequest from "../../utils/axios";
import { getConfigFromParamStore, getConfigFromStroage } from '../../utils/getUrlsFromAws';

const axios = new AxiosRequest().getClient()

class Pdf extends Component {
    constructor() {
        super();
        this.state = {
            errorMsg: '',
            showPopUp: false,
            label: "Password",
            password: "",
            correctPassword: "",
            passwordErr: false
        }
    }

    componentDidMount() {
        this.getPdf();
    }

    handlePopUpDisplay = () => {
        if (this.state.showPopUp == false) {
            this.setState({ showPopUp: true })
        } else {
            this.setState({ showPopUp: false })
        }
    }

    handleInputChange = (e) => {
        const { name, value } = e.target
        this.setState({ [name]: value, label: "Password", passwordErr: false })
    }

    onSubmitPassword = async () => {
        this.props.showLoader(true)
        const { password, transcriptFile } = this.state
        const { url, body } = getApiData('pdf');
        body.request.payload.posvRefNumber = this.props.txnId;
        body.request.payload.action = "open";
        body.request.payload.password = password;
        console.log(url)
        console.log(body)
        try {
            const res = await axios.post(url, body)
            const { response } = res.data;
            if (response && response.msgInfo && response.msgInfo.msgCode == '200') {
                const opened = window.open('', '_self');
                opened.document.write(transcriptFile);
                this.setState({ showPopUp: false })
            } else {
                this.setState({ label: "Password Incorrect", passwordErr: true })
            }
        } catch (err) {
            this.setState({ errorMsg: "Something went wrong ! Please try again later.", showPopUp: false })
        } finally {
            this.props.showLoader(false)
        }

        // if (password == correctPassword) {
        //     const opened = window.open('', '_self');
        //     opened.document.write(transcriptFile);
        //     this.setState({ showPopUp: false })
        //     // this.getPdf()
        // } else {
        //     this.setState({ label: "Password Incorrect",passwordErr:true })
        // }
    }

    onCancel = () => {
        this.setState({ errorMsg: "Please close the tab and click on the link.", showPopUp: false })
    }

    getLabelClass = () => {
        if (this.state.passwordErr) {
            return "label-password err-label"
        } else {
            return "label-password"
        }
    }

    getPdf = async () => {
        this.props.showLoader(true)
        let urlsData = getConfigFromStroage();
        if (!urlsData) {
            const resp = await getConfigFromParamStore()
        }
        const { url, body } = getApiData('pdf');
        body.request.payload.posvRefNumber = this.props.txnId;
        delete body.request.payload.action
        delete body.request.payload.password
        try {
            const res = await axios.post(url, body)
            const { response } = res.data;

            if (response && response.msgInfo && response.msgInfo.msgCode === '500') {
                this.setState({ errorMsg: response.msgInfo.msgDescription })
                return
            }
            if (res.data.response.payload.passwordProtected == "Y") {
                this.setState({ transcriptFile: res.data.response.payload.transcriptFile })
                this.handlePopUpDisplay()
                this.props.showLoader(false)
            } else {
                this.props.showLoader(false)
                const { transcriptFile } = res.data.response.payload;
                const opened = window.open('', '_self');
                opened.document.write(transcriptFile);
            }
        } catch (err) {
            // this.setState({ loading: false })
        } finally {
            this.props.showLoader(false)
        }
    }

    render() {
        return (
            <>
                {this.props.loading ? <>
                    <div className="display_text">
                        Please wait ...
                    </div>
                </> : null}
                {this.state.showPopUp ? <div className="popup-box" >
                    <div className="password_popup" >
                        <h2>This file is protected</h2>
                        <div className="form-group" >
                            <label className={this.getLabelClass()} >{this.state.label}</label>
                            <input type="password" name="password" value={this.state.password} onChange={this.handleInputChange} />
                        </div>
                        <div className="popup-btn-cntnr">
                            <button className="option-btn" onClick={this.onCancel} >Cancel</button>
                            <button className="option-btn" onClick={this.onSubmitPassword} >Open</button>
                        </div>
                    </div>
                </div> : null}
                {this.state.errorMsg ? <div className="display_text">
                    {this.state.errorMsg}
                </div> : null}
            </>
        )
    }
}
export default connect(null, { showLoader })(withRouter(Pdf));